export const APP_BACK_HIDE = "APP_BACK_HIDE";
export const APP_BACK_SHOW = "APP_BACK_SHOW";
export const APP_DONE = "APP_DONE";
export const APP_READY = "APP_READY";
export const APP_RESET = "APP_RESET";
export const APP_SET_BACK_PAGE = "APP_SET_BACK_PAGE";
export const APP_SET_CONFIG = "APP_SET_CONFIG";
export const APP_SET_LANGUAGE = "APP_SET_LANGUAGE";
export const APP_SET_PLATE = "APP_SET_PLATE";
export const APP_SET_ROUTE = "APP_SET_ROUTE";
export const APP_SET_ROUTE_DONE = "APP_SET_ROUTE_DONE";
export const APP_SET_TAB = "APP_SET_TAB";
export const APP_WAIT = "APP_WAIT";

export const DELIVERIES_ERROR = "DELIVERIES_ERROR";
export const DELIVERIES_CONNECT = "DELIVERIES_CONNECT";
export const DELIVERIES_DISCONNECT = "DELIVERIES_DISCONNECT";
export const DELIV_DONE = "DELIV_DONE";
export const DELIVERIES_UPDATE = "DELIVERIES_UPDATE";
export const DELIV_START = "DELIV_START";
export const DELIV_START_UPD = "DELIV_START_UPD";

export const DIALOG_OPEN = "DIALOG_OPEN";
export const DIALOG_BTN1 = "DIALOG_BTN1";
export const DIALOG_BTN2 = "DIALOG_BTN2";
export const DIALOG_CLOSE = "DIALOG_CLOSE";
export const DIALOG_WAIT = "DIALOG_WAIT";

export const LOGIN_DONE = "LOGIN_DONE";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_CONFIRMED = "LOGOUT_CONFIRMED";
export const LOGOUT_CANCEL = "LOGOUT_CANCEL";

export const ORDER_DELIV_CANCEL = "ORDER_DELIV_CANCEL";
export const ORDER_DELIV_COMPLETE = "ORDER_DELIV_COMPLETE";
export const ORDER_DONE = "ORDER_DONE";
export const ORDERS_UPDATE = "ORDERS_UPDATE";

export const PROFILE_UPDATE = "PROFILE_UPDATE";
export const PROFILE_READ = "PROFILE_READ";

export const SENSORS_ERROR = "SENSORS_ERROR";
export const SENSORS_CONNECT = "SENSORS_CONNECT";
export const SENSORS_DISCONNECT = "SENSORS_DISCONNECT";
export const SENSORS_UPDATE = "SENSORS_UPDATE";



// WEBPACK FOOTER //
// ./src/constants/action-types.js